import { FC, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Form } from "capitalrx-components-2.0/lib/forms";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

import { generateForgotPasswordEmail } from "@/App/api/login";
import { ClientAwareLink } from "@/App/components/ClientAwareLink";
import { ANALYTIC_EVENTS, logEvent } from "@/App/service/analyticsService";
import { CodeSentForm } from "./CodeSentForm";
import { RequestEmailForm } from "./RequestEmailForm";

interface ForgotPasswordForm {
  readonly email: string;
  readonly memberId: string;
}

export const ForgotPasswordPage: FC = () => {
  const { t: translate } = useTranslation();
  const form = useForm<ForgotPasswordForm>({
    defaultValues: {
      email: "",
      memberId: "",
    },
  });
  const [formId, setFormId] = useState<"requestCode" | "codeSent">("requestCode");
  const alert = useAlert();

  const submitForm = async (formData: ForgotPasswordForm) => {
    const { email, memberId } = formData;
    try {
      await generateForgotPasswordEmail({
        identity: email,
        external_member_id: memberId,
      });
      setFormId("codeSent");
    } catch(e) {
      logEvent(ANALYTIC_EVENTS.ERRORS.verifyUser);
      alert({
        message: e?.data?.message || translate("FORGOT_PASSWORD.forgotPasswordPage.unableToSendCode"),
        type: "error",
        style: "toast",
      });
    }
  };

  return (
    <Form form={form} onSubmit={submitForm} testId="forgot-password">
      <Stack>
        {formId === "requestCode" && <RequestEmailForm />}
        {formId === "codeSent" && <CodeSentForm />}
        <Shelf>
          <Shelf.Spacer />
          <ClientAwareLink testId="go-to-login" to="/login">{translate("FORGOT_PASSWORD.forgotPasswordPage.backToLogin")}</ClientAwareLink>
          <Shelf.Spacer />
        </Shelf>
      </Stack>
    </Form>
  );
};
